<template>
  <div>
    <div class="container mx-auto">
      <div class="w-1/2 my-15">
        <h1 class="text-4xl text-btw-900 mb-5 font-medium">
          Thank You for Joining Us!
        </h1>
        <p class="font-normal leading-6">
          Get ready for a digital journey filled with innovation, creativity,
          and valuable insights. Stay tuned for exciting updates, exclusive
          content, and opportunities to connect with like-minded individuals.
        </p>
      </div>

      <!-- ARTICLES -->
      <div class="mb-15">
        <div class="mb-12">
          <h2
            class="mb-8 font-medium text-black-900 text-[22px] leading-normal sm:text-[40px] sm:leading-[50px]"
          >
            Explore Our Expert Insights
          </h2>

          <div
            v-if="isLoading"
            class="rounded grid sm:grid-cols-none md:grid=cols-3 lg:grid-cols-4 place-items-center gap-11"
          >
            <div v-for="index in 4" :key="index" class="w-full">
              <UtilsSkeletonLoading class="rounded-lg h-40 w-full mb-4" />
              <UtilsSkeletonLoading class="w-full h-12 mb-3" />
              <UtilsSkeletonLoading class="w-full h-12" />
            </div>
          </div>

          <div
            v-else
            class="grid gap-11 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-none"
          >
            <ArticleCard v-for="i in 4" :key="i" />
          </div>
        </div>

        <div class="flex justify-center items-center w-full">
          <NuxtLink class="btn btn-primary-reverse btn-md" to="" title="Ideas"
            >View All Articles</NuxtLink
          >
        </div>
      </div>
    </div>
    <!-- ARTICLES -->
  </div>
</template>

<script setup>
// ARTICLE LIST
const isLoading = ref(true)
setTimeout(() => {
  isLoading.value = false
}, 2000)
</script>
